(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ma-collection-explorer"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ma-collection-explorer')) {
    customElements.define('ma-collection-explorer', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.track = this.querySelector('.ma-explorer__track');
        this.back = this.querySelector('.ma-explorer__back');
        this.progress = this.querySelector('.ma-explorer__progress');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.setAttribute('data-ready', '');
        this.addEventListener('click', (event) => {
          if (performance.now() < (this.suppressUntil || 0)) { event.preventDefault(); event.stopPropagation(); return; }
          const toggle = event.target.closest('.ma-explorer__toggle');
          if (toggle) this.toggle(toggle);
          if (event.target.closest('.ma-explorer__back') && this.openButton) this.toggle(this.openButton, true);
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.openButton) { event.preventDefault(); this.toggle(this.openButton, true); }
          if (event.target === this.track && ['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
            event.preventDefault();
            const step = this.track.querySelector('.ma-explorer__card').getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap);
            const left = event.key === 'Home' ? 0 : event.key === 'End' ? this.track.scrollWidth : this.track.scrollLeft + (event.key === 'ArrowLeft' ? -step : step);
            this.track.scrollTo({ left, behavior:this.reduced.matches ? 'instant' : 'smooth' });
          }
        }, options);
        this.track.addEventListener('scroll', () => this.updateProgress(), { ...options, passive:true });
        this.track.addEventListener('dragstart', (event) => event.preventDefault(), options);
        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button')) return;
          this.drag = { id:event.pointerId, x:event.clientX, scroll:this.track.scrollLeft, moved:false };
        }, options);
        this.track.addEventListener('pointermove', (event) => {
          if (!this.drag) return;
          const delta = event.clientX - this.drag.x;
          if (Math.abs(delta) > 6 && !this.drag.moved) { this.drag.moved = true; this.track.setPointerCapture(event.pointerId); this.track.classList.add('is-dragging'); }
          if (this.drag.moved) { event.preventDefault(); this.track.scrollLeft = this.drag.scroll - delta; }
        }, options);
        const endDrag = () => {
          if (this.drag?.moved) this.suppressUntil = performance.now() + 350;
          this.drag = null;
          this.track.classList.remove('is-dragging');
        };
        this.track.addEventListener('pointerup', endDrag, options);
        this.track.addEventListener('pointercancel', endDrag, options);
        this.track.addEventListener('lostpointercapture', endDrag, options);
        this.track.addEventListener('pointerleave', () => { if (!this.drag?.moved) this.drag = null; }, options);
        document.addEventListener('shopify:block:select', (event) => {
          const group = Array.from(this.querySelectorAll('[data-block-id]')).find(node => node.dataset.blockId === event.detail.blockId);
          if (group) this.align(group.querySelector('.ma-explorer__hero'));
        }, options);
        this.observer = new ResizeObserver(() => this.updateProgress());
        this.observer.observe(this.track);
        this.updateProgress();
      }
      toggle(button, focus = false) {
        this.getAnimations({ subtree:true }).forEach(animation => animation.cancel());
        const before = new Map(Array.from(this.track.querySelectorAll('.ma-explorer__card')).filter(card => card.getClientRects().length).map(card => [card, card.getBoundingClientRect().left]));
        const oldHeight = this.track.getBoundingClientRect().height;
        const opening = button !== this.openButton;
        if (this.openButton) {
          const old = this.openButton;
          this.querySelector('#' + CSS.escape(old.getAttribute('aria-controls'))).hidden = true;
          old.setAttribute('aria-expanded', 'false');
          old.setAttribute('aria-label', old.dataset.openLabel);
        }
        const panel = this.querySelector('#' + CSS.escape(button.getAttribute('aria-controls')));
        panel.hidden = !opening;
        button.setAttribute('aria-expanded', String(opening));
        button.setAttribute('aria-label', opening ? button.dataset.closeLabel : button.dataset.openLabel);
        this.openButton = opening ? button : null;
        this.back.hidden = !opening;
        this.querySelector('[data-announcement]').textContent = button.getAttribute('aria-label');
        if (focus) button.focus({ preventScroll:true });
        const hero = button.closest('.ma-explorer__hero');
        const left = this.track.scrollLeft + hero.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left, behavior:'instant' });
        if (!this.reduced.matches) {
          const easing = 'cubic-bezier(.22,1,.36,1)';
          const viewport = this.track.getBoundingClientRect();
          this.track.querySelectorAll('.ma-explorer__card').forEach(card => {
            if (!card.getClientRects().length) return;
            const rect = card.getBoundingClientRect();
            if (rect.right < viewport.left || rect.left > viewport.right) return;
            const previous = before.get(card);
            const shift = previous === undefined ? 18 : Math.max(-viewport.width,Math.min(viewport.width,previous - rect.left));
            card.animate([{ opacity:previous === undefined ? 0 : 1, transform:`translateX(${shift}px)` },{ opacity:1, transform:'translateX(0)' }], { duration:560, easing });
          });
          const nextHeight = this.track.getBoundingClientRect().height;
          if (Math.abs(nextHeight - oldHeight) > 1) this.track.animate([{height:oldHeight+'px'},{height:nextHeight+'px'}],{duration:560,easing});
        }
        this.updateProgress();
      }
      align(card) {
        if (!card) return;
        const left = this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left, behavior:this.reduced.matches ? 'instant' : 'smooth' });
      }
      updateProgress() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const width = Math.max(12, 64 * this.track.clientWidth / Math.max(1,this.track.scrollWidth));
        this.progress.style.setProperty('--ma-thumb', width + 'px');
        this.progress.style.setProperty('--ma-position', (max > 0 ? (64 - width) * Math.max(0,Math.min(1,this.track.scrollLeft / max)) : 0) + 'px');
        this.progress.style.visibility = max > 1 ? 'visible' : 'hidden';
      }
      disconnectedCallback() { this.controller?.abort(); this.controller = null; this.observer?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
function setupMuscleapeSlides(root) {
  root.querySelectorAll('slideshow-component.ma-minimal-home').forEach((component) => {
    if (component.dataset.maSwipeReady) return;
    const slider = component.querySelector('.slideshow');
    if (!slider) return;
    component.dataset.maSwipeReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const visibleSlides = () => Array.from(slider.querySelectorAll('.slideshow__slide')).filter((slide) => slide.clientWidth > 0);
    let drag = null;
    let suppressClick = false;
    let clickReset;
    slider.addEventListener('dragstart', (event) => event.preventDefault());
    slider.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('button, input, video, model-viewer')) return;
      drag = { id: event.pointerId, x: event.clientX, left: slider.scrollLeft, moved: false };
    });
    slider.addEventListener('pointermove', (event) => {
      if (!drag || drag.id !== event.pointerId) return;
      const delta = event.clientX - drag.x;
      if (!drag.moved && Math.abs(delta) < 6) return;
      if (!drag.moved) {
        drag.moved = true;
        slider.classList.add('is-dragging');
        slider.setPointerCapture(event.pointerId);
      }
      event.preventDefault();
      slider.scrollLeft = drag.left - delta;
    });
    const finishDrag = (event) => {
      if (!drag || drag.id !== event.pointerId) return;
      const moved = drag.moved;
      drag = null;
      slider.classList.remove('is-dragging');
      if (slider.hasPointerCapture(event.pointerId)) slider.releasePointerCapture(event.pointerId);
      if (!moved) return;
      suppressClick = true;
      clearTimeout(clickReset);
      clickReset = setTimeout(() => { suppressClick = false; }, 350);
      const slides = visibleSlides();
      const nearest = slides.reduce((best, slide) => Math.abs(slide.offsetLeft - slider.scrollLeft) < Math.abs(best.offsetLeft - slider.scrollLeft) ? slide : best, slides[0]);
      if (nearest) slider.scrollTo({ left: nearest.offsetLeft, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
    };
    slider.addEventListener('pointerup', finishDrag);
    slider.addEventListener('pointercancel', finishDrag);
    slider.addEventListener('lostpointercapture', finishDrag);
    slider.addEventListener('click', (event) => {
      if (!suppressClick) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      suppressClick = false;
    }, true);
    component.addEventListener('keydown', (event) => {
      if (!event.target.closest('.slider-counter__link') || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const dots = Array.from(component.querySelectorAll('.slider-counter__link'));
      const current = dots.indexOf(event.target.closest('.slider-counter__link'));
      let next = event.key === 'Home' ? 0 : event.key === 'End' ? dots.length - 1 : current + (event.key === 'ArrowRight' ? 1 : -1);
      next = Math.max(0, Math.min(dots.length - 1, next));
      event.preventDefault();
      dots[next].focus();
      dots[next].click();
    });
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => setupMuscleapeSlides(document));
else setupMuscleapeSlides(document);
document.addEventListener('shopify:section:load', (event) => setupMuscleapeSlides(event.target.parentElement || document));


  } catch(e) { console.error(e); }
})();
})();
